'../<template>
  <div class="body">

    <!-- Intro -->
    <b-container class="section intro" id="intro" data-color="#1E22AA" data-border="#141B4D">
      <b-row class="header">
        <div v-if="mobile" class="section-header mobile intro">
          <b-col cols="10" class="parallax-wrapper mx-auto" v-parallax="-0.1">
            <h1>We are<br>Franchising</h1>
          </b-col>
        </div>
        <div v-else class="section-header intro">
          <b-col offset="2" cols="8" class="parallax-wrapper" v-parallax="-0.2">
            <h1>We are<br>Franchising</h1>
          </b-col>
        </div>
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p>In 2017, the International Franchise Association (IFA) achieved many new accomplishments &mdash; from record-breaking attendance at the Annual Convention to an upswell of grassroots advocates urging members of Congress to do more for the franchise community. Such milestones were reached through a focus on educating the franchise community and a commitment to a more inclusive, diverse environment.</p>
        </b-col>
      </b-row>
      <b-row class="section-statistics">
        <div class="statistics-bg upper"></div>
        <div class="statistics-wrapper">
          <div class="parallax-wrapper" v-parallax="parallaxSpeed">
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <div class="numbers">
                  <animated-counter v-bind:value="firstNumber"></animated-counter>
                </div>
                <span>IFA MEMBERS</span>
              </div>
            </b-col>

            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <div class="numbers">
                  <animated-counter v-bind:value="secondNumber"></animated-counter>
                </div>
                <span>LETTERS SENT TO CONGRESSIONAL REPS</span>
              </div>
            </b-col>

            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <span>THE FUTURE OF FRANCHISING CAMPAIGN GREW THE FOUNDATION'S RESOURCES TO OVER</span>
                <div class="numbers">
                  $<animated-counter v-bind:value="thirdNumber"></animated-counter>M
                </div>
              </div>
            </b-col>

          </div>
        </div>
        <div class="statistics-bg lower"></div>
      </b-row>
      <b-row class="full-image">
        <b-col cols="12" class="mx-auto image">
          <img class="loaded mobile-img" v-if="mobile && screenWidth == 'sm'" :src="introImage_mobile">
          <img class="loaded mobile-img" v-else-if="mobile && screenWidth == 'md'" :src="introImage">
          <img class="loaded full" v-else-if="!mobile && screenWidth == 'lg'" :src="introImage2x">
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p class="section-body">These community-wide wins were made possible through the collective efforts of our stakeholders and members. The franchise community is poised for bold new successes in 2018 because of the strong focus on education and advocacy participation this past year. IFA is optimistic about this next year in franchising, and you should be too.</p>
        </b-col>
      </b-row>
    </b-container>


    <!-- First section -->
    <b-container class="section first" id="first" data-color="#3CDBC0" data-border="#29C1A7" >
      <b-row class="header">
        <!-- <b-col> -->
        <div v-if="mobile" class="section-header mobile one">
          <b-col cols="10" class="parallax-wrapper mx-auto" v-parallax="-0.1">
            <span>Government Relations</span>
            <h2>PROACTIVELY SHAPING POLICY THROUGH RELATIONSHIP BUILDING</h2>
          </b-col>
        </div>
        <div v-else class="section-header one">
          <b-col offset="2" cols="8" class="parallax-wrapper" v-parallax="-0.2">
            <span>Government Relations</span>
            <h2>PROACTIVELY SHAPING POLICY THROUGH RELATIONSHIP BUILDING</h2>
          </b-col>
        </div>
        <!-- </b-col> -->
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p>The IFA's government relations team focused their 2017 efforts on proactively shaping policy to support franchising by building relationships throughout the halls of Congress. The team participated in Congressional Black Caucus and Hispanic Caucus events to develop and strengthen working rapport with key members of Congress. Their proactivity led to critical pro-franchising legislative accomplishments including:</p>
          <ul>
            <li>The House-passed, bipartisan Save Local Business Act, a policy solution that addresses the uncertainty of joint employer standards felt by local businesses.</li>
            <li>The Veteran Entrepreneurs Act, a bill garnering support from both sides of the aisle that would make franchise ownership more financially accessible to veterans.</li>
            <li>A new task force of IFA staff and experts that engaged the Securities Exchange Commission and Financial Accounting Standards Board head on to protect franchisors, ensuring these entities acknowledge the multiple performance obligations of initial franchise fees.</li>
          </ul>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mx-auto" md="8">
          <iframe src="https://www.youtube.com/embed/35kZDI6JNvY" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          <p class="video-caption">The IFA and the U.S. Chamber of Commerce launched this ad to proactively urge Congress to pass the Save Local Business Act (H.R. 3441).</p>
        </b-col>
      </b-row>
      <b-row class="section-quote section-transparent">
        <div class="transparent-wrapper">
          <b-col lg="4">
            <div class="quote-wrapper">
              <div class="quote-svg"></div>
              <div class="quote">
                We made it a high priority to engage with the SEC and the FASB this year on your behalf, and we were successful.<br><br><span>- Shelly Sun, IFA Chair</span>
              </div>
            </div>
          </b-col>
          <b-col lg="8">
            <iframe src="https://www.youtube.com/embed/V8jfUgAsZQI" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          </b-col>
        </div>
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p>IFA advocacy programs FranPAC and the Franchise Action Network (FAN) grew stronger in 2017 and played a major role in securing policy victories for franchising. These programs made IFA's meetings with more than 200 members of Congress possible and successful. Advocates from these programs showed up in full force throughout the year, particularly to oppose the joint employer policy. Individuals sent 118,901 joint employer-related letters to Congress and 28 franchise community members testified on the federal stage about the topic.</p>
        </b-col>
      </b-row>
      <b-row class="section-statistics">
        <div class="statistics-bg upper"></div>
        <div class="statistics-wrapper">
          <div class="parallax-wrapper" v-parallax="parallaxSpeed">
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <div class="numbers">
                  <animated-counter :value="fourthNumber"></animated-counter>+
                </div>
                <span>GOV RELATIONS MEETINGS WITH MEMBERS OF CONGRESS</span>
              </div>
            </b-col>
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <div class="numbers">
                  $<animated-counter :decimal="1" :value="fifthNumber"></animated-counter><br>
                  BILLION<br>
                </div>
                <span>ESTIMATED ANNUAL TAX SAVINGS FROM PASS-THROUGH DEDUCTIONS</span>
              </div>
            </b-col>
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <div class="numbers">
                  <animated-counter :value="sixthNumber"></animated-counter>
                </div>
                <span>JOINT EMPLOYER GRASSROOTS LETTERS</span>
              </div>
            </b-col>
          </div>
        </div>
        <div class="statistics-bg lower"></div>
      </b-row>
    </b-container>


    <!-- Second section -->
    <b-container class="section second" id="second" data-color="#EAAA00" data-border="#CC9400" ref="container">
      <b-row class="header">
        <!-- <b-col> -->
        <div v-if="mobile" class="section-header mobile two">
          <b-col cols="10" class="parallax-wrapper mx-auto" v-parallax="-0.1">
            <span>Marketing, Membership and Events</span>
            <h2>A YEAR OF UNPRECEDNETED ATTENDANCE AND PARTICIPATION INDUSTRY-WIDE</h2>
          </b-col>
        </div>
        <div v-else class="section-header two">
          <b-col offset="2" cols="8" class="parallax-wrapper" v-parallax="-0.2">
            <span>Marketing, Membership and Events</span>
            <h2>A YEAR OF UNPRECEDENTED ATTENDANCE AND PARTICIPATION INDUSTRY-WIDE</h2>
          </b-col>
        </div>
        <!-- </b-col> -->
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p>Ensuring that franchising's message was effectively spread throughout the community was key to making 2017 a year filled with unprecedented accomplishments. Membership growth was not the only indication of an engaged community. IFA members were highly engaged throughout the year:</p>
          <ul>
            <li>Annual Convention attendance reached highest numbers on record compared to previous years.</li>
            <li>The first ever emerging Franchisor Bootcamp sold out.</li>
          </ul>
          <p>The IFA made it a point to touch the lives of the franchise community, and the franchise community responded:</p>
          <ul>
            <li>Nearly 27,000 followers on social channels</li>
            <li>More than 30,000 email subscribers</li>
            <li>Almost 15,000 Franchising World print circulation</li>
          </ul>
        </b-col>
      </b-row>
      <b-row class="section-statistics">
        <div class="statistics-bg upper"></div>
        <div class="statistics-wrapper">
          <div class="parallax-wrapper" v-parallax="parallaxSpeed">
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <span>ENGAGED MORE THAN</span>
                <div class="numbers">
                  <animated-counter :value="seventhNumber"></animated-counter>
                </div>
                <span>MEMBERS OF THE FRANCHISE COMMUNITY IN NATIONWIDE EVENTS</span>
              </div>
            </b-col>
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <span>NEARLY</span>
                <div class="numbers">
                  <animated-counter :value="eighthNumber"></animated-counter>
                </div>
                <span>ATTENDEES AT 2017's ANNUAL CONVENTION</span>
              </div>
            </b-col>
            <b-col md="4" sm="12">
              <div class="stats-border-wrapper">
                <div class="numbers">
                  <animated-counter :value="ninthNumber"></animated-counter>
                </div>
                <span>INDIVIDUALS REACHED THROUGH IFA’S DIGITAL PRESENCE</span>
              </div>
            </b-col>
          </div>
        </div>
        <div class="statistics-bg lower"></div>
      </b-row>
      <b-row>
        <b-col md="8" offset-md="2">
          <iframe src="https://www.youtube.com/embed/FjOtQy1gYIo" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          <p class="video-caption">The IFA's 2017 Annual Convention had a record number of attendees who came together to learn about the most exciting tips and trends in franchising.</p>
        </b-col>
      </b-row>
      <b-row class="grid section-transparent">
        <div class="transparent-wrapper" v-if="firstImages && !mobile">
          <b-col md="4" sm="6" v-for="(item,index) in firstImages" :key="index">
            <a class="activateModal" :title="item.title" v-bind:data-image="item.url" @click="showModal($event,'firstImages',index)">
              <img v-lazy.container="item.thumbnail">
              <div class="hover-caption" @click="showModal($event,'firstImages',index)">
                <div class="caption-wrapper">
                  <span>{{ item.hover_caption }}</span>
                </div>
              </div>
            </a>
          </b-col>
        </div>
        <div class="transparent-wrapper" v-else-if="mobile">
          <b-col cols="12">
            <b-carousel id="carousel1_mobile" interval
                  class="mobile"
                  style="text-shadow: 1px 1px 2px #333;"
                  controls
                  indicators
                  >
                <b-carousel-slide v-if="firstImages" v-for="(item,index) in firstImages" :key="index" :id="item.slug" :img-src="item.mobile">
                </b-carousel-slide>
            </b-carousel>
          </b-col>
        </div>
      </b-row>
      <b-modal size="lg" centered lazy ref="firstImages" id="firstImages">
        <b-carousel id="carousel1" interval
              style="text-shadow: 1px 1px 2px #333;"
              controls
              indicators
              v-model="activeImage"
              >
              <b-carousel-slide v-if="firstImages" v-for="(item,index) in firstImages" :key="index" :id="item.slug" :img-src="item.url">
              </b-carousel-slide>
        </b-carousel>
      </b-modal>
    </b-container>


    <!-- Third section -->
    <b-container class="section third" id="third" data-color="#E04E39" data-border="#BA3E2C" ref="container">
      <b-row class="header">
        <div v-if="mobile" class="section-header mobile three">
          <b-col cols="10" class="parallax-wrapper mx-auto" v-parallax="-0.1">
            <span>The Foundation</span>
            <h2>Strengthening the Franchise Community Through Education, Research and Programming</h2>
          </b-col>
        </div>
        <div v-else class="section-header three">
          <b-col offset="2" cols="8" class="parallax-wrapper" v-parallax="-0.2">
            <span>The Foundation</span>
            <h2>Strengthening the Franchise Community Through Education, Research and Programming</h2>
          </b-col>
        </div>
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p class="section-body">In addition to successes in policy and government relations, the IFA strengthened the franchising community through state of the art education and outreach programs. Thanks to the educational tools, research projects and causes championed by The Foundation, the franchise community had continuous opportunities, tools and resources to flourish &mdash; and people took advantage. The Certified Franchise Executive (CFE) program yielded the largest graduating class in its history, proving the franchise community is full of engaged individuals who want to learn more. Franchising won accolades for diversity, gender pay equality and veteran engagement, all areas actively championed and supported by the IFA and its Foundation. The Foundation's annual recognition and encouragement of community service and global competition for the brightest millennials in franchising continues to energize the community.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8" offset-md="2">
          <iframe src="https://www.youtube.com/embed/NiXDiPLS9ss" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          <p class="video-caption">From enhancing the knowledge of the franchise community to providing research that helps advance IFA's advoacy efforts, The Foundation is an integral part of IFA's success every year.</p>
        </b-col>
      </b-row>
      <b-row class="grid section-transparent">
        <div class="transparent-wrapper" v-if="secondImages && !mobile">
          <b-col cols="6" md="4" v-if="secondImages" v-for="(item,index) in secondImages" :key="index">
            <a class="activateModal" :title="item.title" v-bind:data-image="item.url" @click="showModal($event,'secondImages',index)">
              <img v-lazy.container="item.thumbnail">
              <div class="hover-caption" @click="showModal($event,'secondImages',index)">
                <div class="caption-wrapper">
                  <span>{{ item.hover_caption }}</span>
                </div>
              </div>
            </a>
          </b-col>
        </div>
        <div class="transparent-wrapper" v-else-if="mobile">
          <b-col cols="12">
            <b-carousel id="carousel2_mobile" interval
                  style="text-shadow: 1px 1px 2px #333;"
                  class="mobile"
                  controls
                  indicators
                  >
                <b-carousel-slide v-if="secondImages" v-for="(item,index) in secondImages" :key="index" :id="item.slug" :img-src="item.mobile" :text="item.modal_caption">
                </b-carousel-slide>
            </b-carousel>
          </b-col>
        </div>
      </b-row>
      <b-modal size="lg" centered lazy ref="secondImages" id="secondImages">
        <b-carousel id="carousel1" interval
              style="text-shadow: 1px 1px 2px #333;"
              controls
              indicators
              v-model="activeImage"
              >
              <b-carousel-slide v-if="secondImages" v-for="(item,index) in secondImages" :key="index" :id="item.slug" :img-src="item.url" :text="item.modal_caption">
              </b-carousel-slide>
        </b-carousel>
      </b-modal>
    </b-container>

    <b-container class="section fourth" id="fourth" data-color="#141B4D" data-border="#0B0F2C" ref="container">
      <b-row class="header">
        <div v-if="mobile" class="section-header mobile four">
          <b-col cols="10" class="parallax-wrapper mx-auto" v-parallax="-0.1">
            <span>International</span>
            <h2>SHAPING A FAVORABLE AND INCLUSIVE ECOSYSTEM FOR FRANCHISING WORLDWIDE</h2>
          </b-col>
        </div>
        <div v-else class="section-header four">
          <b-col offset="2" cols="8" class="parallax-wrapper" v-parallax="-0.2">
            <span>International</span>
            <h2>SHAPING A FAVORABLE AND INCLUSIVE ECOSYSTEM FOR FRANCHISING WORLDWIDE</h2>
          </b-col>
        </div>
      </b-row>
      <b-row>
        <b-col offset-md="2" md="8">
          <p class="section-body">The IFA's efforts to support the franchise community did not stop at U.S. borders. The organization's efforts ensured that franchising was represented across the globe &mdash; and saw joint employer successfully confronted in two more countries: Canada and Brazil. The IFA played leading roles at a range of key international franchising events including:</p>
          <ul>
            <li>World Franchise Council meetings in London and Istanbul</li>
            <li>The International Franchising Symposium co-organized by IFA in London</li>
            <li>The Global Restaurant Leadership Conference in Dubai, UAE</li>
            <li>The International Franchise Expo in New York</li>
            <li>The International Franchise Conference and Expo in Abu Dhabi, UAE</li>
          </ul>
          <p>These international efforts elevated franchising's profile domestically as well. The U.S. Secretary of Commerce and U.S. Trade Representative appointed IFA's vice president of international affairs, Josh Merin, to serve as a cleared trade advisor. Take a look at some of the spots around the globe where the IFA influenced the franchise community.</p>
        </b-col>
      </b-row>
      <b-row class="grid section-transparent">
        <div class="transparent-wrapper" v-if="thirdImages && !mobile">
          <b-col md="4" sm="6" v-if="thirdImages" v-for="(item,index) in thirdImages" :key="index">
            <a class="activateModal" :title="item.title" v-bind:data-image="item.url" @click="showModal($event,'thirdImages',index)">
              <img v-lazy.container="item.thumbnail">
              <div class="hover-caption" @click="showModal($event,'thirdImages',index)">
                <div class="caption-wrapper location">
                  <span class="location-text">{{ item.location }}</span>
                  <span>{{ item.hover_caption }}</span>
                </div>
              </div>
            </a>
          </b-col>
        </div>
        <div class="transparent-wrapper" v-else-if="mobile">
          <b-col cols="12">
            <b-carousel id="carousel3_mobile" interval
                  style="text-shadow: 1px 1px 2px #333;"
                  class="mobile"
                  controls
                  indicators
                  >
                <b-carousel-slide v-if="thirdImages" v-for="(item,index) in thirdImages" :key="index" :id="item.slug" :img-src="item.mobile" :text="item.modal_caption">
                </b-carousel-slide>
            </b-carousel>
          </b-col>
        </div>
      </b-row>
      <b-modal size="lg" centered lazy ref="thirdImages" id="thirdImages">
        <b-carousel id="carousel1" interval
              style="text-shadow: 1px 1px 2px #333;"
              controls
              indicators
              v-model="activeImage"
              >
              <b-carousel-slide v-if="thirdImages" v-for="(item,index) in thirdImages" :key="index" :id="item.slug" :img-src="item.url" :text="item.modal_caption">
              </b-carousel-slide>
        </b-carousel>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
// import Parallax from 'vue-parallaxy'
import bCarousel from 'bootstrap-vue/es/components/carousel/carousel'
import AnimatedCounter from './AnimatedCounter.vue'
var json_file = require('../images.json')

// animated numbers
const INTRO_NUMBERS_1 = 15810
const INTRO_NUMBERS_2 = 119350
const INTRO_NUMBERS_3 = 10

const FIRST_NUMBERS_1 = 200
const FIRST_NUMBERS_2 = 2.5
const FIRST_NUMBERS_3 = 118901

const MEMBERS_FRANCHISE_COMMUNITY = 5500
const ANNUAL_CONVENTION_ATTENDEES = 4000
const LOREM_IPSUM = 972192


export default {
  name: 'Body',
  components: {
    bCarousel, AnimatedCounter
  },
  data() {
    return {
      mobile: false,
      activeImage: 0,
      firstImages: null,
      secondImages: null,
      thirdImages: null,
      firstNumber: 0,
      secondNumber: 0,
      thirdNumber: 0,
      fourthNumber: 0,
      fifthNumber: 0,
      sixthNumber: 0,
      seventhNumber: 0,
      eighthNumber: 0,
      ninthNumber: 0,
      parallaxSpeed: -0.1,
      screenWidth: "",
      introImage_mobile: '/2017-annual-report/static/images/Healthcare_Exec_order_IFA_group_mobile.jpg',
      introImage: '/2017-annual-report/static/images/Healthcare_Exec_order_IFA_group@1x.jpg',
      introImage2x: '/2017-annual-report/static/images/Healthcare_Exec_order_IFA_group@2x.jpg',
    }
  },
  methods: {
    getWindowWidth () {
      if(document.documentElement.clientWidth){
        if(document.documentElement.clientWidth <= 768) {
          this.mobile = true
          this.screenWidth = "sm"
          this.parallaxSpeed = -0.1
        } else if(document.documentElement.clientWidth > 768 && document.documentElement.clientWidth <= 992) {
          this.mobile = true
          this.screenWidth = "md"
          this.parallaxSpeed = -0.1
        } else {
          this.mobile = false
          this.screenWidth = "lg"
          this.parallaxSpeed = -0.2
        }
      }
    },
    showModal (event,group,image_slug) {
      var parentElement = event.target.parentElement
      if(parentElement && parentElement.getAttribute('data-image')){
        this.activeImage = image_slug
        this.$refs[group].show()
      } else if(this.closestParent(parentElement,'.activateModal')){
        var whatup = this.closestParent(parentElement,'.activateModal')
        if(whatup.getAttribute('data-image')){
          this.activeImage = image_slug
          this.$refs[group].show()
        }
      }
    },
    closestParent(el, selector) {
      var matchesFn
      // find vendor prefix
      ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
          if (typeof document.body[fn] == 'function') {
              matchesFn = fn
              return true
          }
          return false
      })
      var parent
      // traverse parents
      while (el) {
          parent = el.parentElement;
          if (parent && parent[matchesFn](selector)) {
              return parent
          }
          el = parent
      }
      return null;
    },
    hideFirstModal () {
      this.$refs.firstModal.hide()
    },
    watchScroll () {
      var _this = this
      var introSection = this.$el.querySelector('#intro .section-statistics')
      var firstSection = this.$el.querySelector('#first .section-statistics')
      var secondSection = this.$el.querySelector('#second .section-statistics')
      var isIE11 = !!window.MSInputMethodContext && !!document.documentMode
      var scrollDepth = window.scrollY
      if(isIE11) {
        scrollDepth = window.pageYOffset
      }
      if(scrollDepth > introSection.offsetTop - 300){
        this.firstNumber = INTRO_NUMBERS_1
        this.secondNumber = INTRO_NUMBERS_2
        this.thirdNumber = INTRO_NUMBERS_3
      }
      if(scrollDepth > firstSection.offsetTop - 300){
        this.fourthNumber = FIRST_NUMBERS_1
        this.fifthNumber = FIRST_NUMBERS_2
        this.sixthNumber = FIRST_NUMBERS_3
      }
      if(scrollDepth > secondSection.offsetTop - 300){
        this.seventhNumber = MEMBERS_FRANCHISE_COMMUNITY
        this.eighthNumber = ANNUAL_CONVENTION_ATTENDEES
        this.ninthNumber = LOREM_IPSUM
      }

      // check the scrollY to determine section and background color
      var firstSection = this.$el.querySelector('#first')
      if(scrollDepth > 0 && (firstSection !== null && scrollDepth < (firstSection.offsetTop - 90))) {
        var baseSection = this.$el.querySelector('#intro')
        var changeColor = baseSection.dataset.color
        var changeBorder = baseSection.dataset.border
        document.querySelector('.body').style.backgroundColor = changeColor
        var nav_list = document.querySelectorAll('.nav li'), i
        for (i = 0; i < nav_list.length; ++i) {
          nav_list[i].classList.remove('active')
        }
        document.querySelector("[data-section='intro']").parentElement.classList.add('active')
      } else {
        var sections = ['first','second','third','fourth','fifth']
        sections.forEach(function(element) {
          var selectSection = _this.$el.querySelector('#'+element)
          if(selectSection !== null && selectSection.offsetTop !== null){
            if(scrollDepth > (selectSection.offsetTop - (screen.height/2))) {
              var changeColor = selectSection.dataset.color
              var changeBorder = selectSection.dataset.border
              document.querySelector('.body').style.backgroundColor = changeColor
              var nav_list = document.querySelectorAll('.nav li'), i
              for (i = 0; i < nav_list.length; ++i) {
                nav_list[i].classList.remove('active')
              }
              document.querySelector("[data-section='"+element+"']").parentElement.classList.add('active')
            }
          }
        })
      }
    }
  },
  mounted () {
    this.firstImages = json_file['first']
    this.secondImages = json_file['second']
    this.thirdImages = json_file['third']
    this.$nextTick(function() {
      window.addEventListener('scroll', this.watchScroll)
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth()
    })
    // this.isChrome = !!window.chrome && !!window.chrome.webstore
    // if(this.isChrome){
    //   var image = this.introImage.src
    //   image = image.slice(0, -4) + '.webp'
    //   this.introImage.src = image
    // }
  },
  destroyed () {
    window.removeEventListener('scroll', this.watchScroll)
    window.removeEventListener('resize', this.getWindowWidth)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../global.scss";
#app .body {
  transition: all 1s ease-in-out;
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  padding: 125px 10px 0 10px;
  background: $blue;
  @media all and (min-width: $md){
    padding-top: 95px;
  }
  // global-ish styles
  .section {
    // margin: 220px auto;
    &:first-child {
      margin-top: 0;
    }
    .row {
      background: $white;
      padding: 40px 9%;
      &.full-image {
        padding: 40px 0;
      }
      @media all and (min-width: $md){
        padding: 45px 0;
      }
      .image {
        background-color: rgba(0,0,0,.05);
      }
      .video-caption {
         padding-top: 10px;
         font-style: italic;
      }
      .mx-auto {
        &.image {
          background-color: rgba(0,0,0,.05);
          height: auto;
          min-height: 135px;
        }
        img {
          text-align: center;
          margin: 0 auto;
          display: block;
          width: 100%;
          // transition: opacity linear .4s 0s;
          // -webkit-transition: opacity linear .4s 0s;
          // -moz-transition: opacity linear .4s 0s;
          background-color: rgba(0,0,0,.05);
          // opacity: 0.5;
          &[lazy=loading] {
            opacity: 0.5;
            filter: blur(10px);
            transition: opacity linear .4s 0s;
            -webkit-transition: opacity linear .4s 0s;
            -moz-transition: opacity linear .4s 0s;
          }
          &[lazy=loaded],&[lazy=error],&.loaded {
            opacity: 1;
          }
        }
      }
      &.header {
        overflow: hidden;
        height: auto;
        padding: 0;
        max-height: 300px;

        @media all and (min-width: $lg){
          height: 500px;
          max-height: 500px;
        }
      }
      &:last-child {
        padding-bottom: 150px;
      }
      &.grid {
        div[class^="col-"] {
          padding: 15px;
          display: inherit;
          a {
            height: 100%;
            display: block;
            width: 100%;
            position: relative;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              transition: opacity linear .4s 0s;
              -webkit-transition: opacity linear .4s 0s;
              -moz-transition: opacity linear .4s 0s;
              background-color: rgba(0,0,0,.05);
              // opacity: 0.5;
              &[lazy=loading] {
                opacity: 0.5;
                transition: opacity linear .4s 0s;
                -webkit-transition: opacity linear .4s 0s;
                -moz-transition: opacity linear .4s 0s;
                filter: blur(10px);
              }
              &[lazy=loaded],&[lazy=error],&.loaded {
                opacity: 1;
              }
            }
            .hover-caption {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: none;
              color: #FFF;
              .caption-wrapper {
                bottom: 25px;
                position: absolute;
                left: 20px;
                padding-top: 5px;
                margin-right: 10px;
                border-top: 5px solid $orange;
                span {
                  font-weight: bold;
                }
                &.location {
                  border-top: none;
                  background-image: url('../assets/location.svg');
                  background-repeat: no-repeat;
                  background-position: 3px 0px;
                  background-size: 25px 35px;
                  padding: 45px 0 0;
                  span {
                    border-top: none;
                    &.location-text {
                      border-top: 5px solid $orange;
                      display: block;
                      text-transform: uppercase;
                      line-height: 35px;
                    }
                  }
                }
              }
            }
            &:hover .hover-caption, &:active .hover-caption {
              @media all and (min-width: $md){
                display: block;
                background-color: rgba(30,34,170,.8);
              }
            }
          }
        }
      }
    }
    iframe {
      min-width: 100%;
      min-height: 400px;
    }
    .section-header {
      height: auto;
      position: relative;
      color: $white;
      min-height: 172px;
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: rgba(0,0,0,.05);
      transition: opacity linear .4s 0s;
      -webkit-transition: opacity linear .4s 0s;
      -moz-transition: opacity linear .4s 0s;
      // opacity: 0.5;
      &[lazy=loading] {
        opacity: 0.5;
        transition: opacity linear .4s 0s;
        -webkit-transition: opacity linear .4s 0s;
        -moz-transition: opacity linear .4s 0s;
        filter: blur(10px);
      }
      &[lazy=loaded],&[lazy=error],&.loaded {
        opacity: 1;
      }
      @media all and (min-width: $md){
        height: 500px;
        background-size: contain;
      }
      @media all and (min-width: $lg){
        background-size: cover;
      }
      .parallax-wrapper {
        z-index: 10;
        @media all and (min-width: $md){
          max-width: 60%;
        }
        h1, h2, span {
          text-align: left;
          display: block;
        }
        span {
          font-size: 14px;
          line-height: 16px;
          @media all and (min-width: $md){
            font-size: 16px;
            line-height: 20px;
          }
        }
      }



      // section specific styles
      &.intro {
        background: url('../../static/images/intro_hero_mobile.jpg') no-repeat;
        background-size: cover;
        @media all and (min-width: $md){
          background: url('../../static/images/intro_hero.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $lg){
          background: url('../../static/images/intro_hero@1x.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $xl){
          background: url('../../static/images/intro_hero@2x.jpg') no-repeat;
          background-size: contain;
        }

        .parallax-wrapper {
          top: 70px;
          position: relative;
          @media all and (min-width: $md){
            top: 150px;
          }
          @media all and (min-width: $lg){
            top: 200px;
          }
          @media all and (min-width: $xl){
            top: 250px;
          }
          h1 {
            text-align: left;
          }
        }
      }
      &.one {
        background: url('../../static/images/first_hero_mobile.jpg') no-repeat;
        background-size: cover;
        @media all and (min-width: $md){
          background: url('../../static/images/first_hero.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $lg){
          background: url('../../static/images/first_hero@1x.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $xl){
          background: url('../../static/images/first_hero@2x.jpg') no-repeat;
          background-size: contain;
        }
        .parallax-wrapper {
          top: 75px;
          position: relative;
          width: 100%;
          @media all and (min-width: $md){
            top: 110px;
          }
          @media all and (min-width: $lg){
            top: 250px;
          }
          @media all and (min-width: $xl){
            width: 80%;
            top: 350px;
          }
          span, h2 {
            text-align: left;
            display: block;
          }
        }
      }
      &.two {
        background: url('../../static/images/second_hero_mobile.jpg') no-repeat;
        background-size: cover;
        @media all and (min-width: $md){
          background: url('../../static/images/second_hero.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $lg){
          background: url('../../static/images/second_hero@1x.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $xl){
          background: url('../../static/images/second_hero@2x.jpg') no-repeat;
          background-size: contain;
        }
        .parallax-wrapper {
          top: 60px;
          position: relative;
          @media all and (min-width: $md){
            top: 100px;
          }
          @media all and (min-width: $lg){
            top: 250px;
          }
          @media all and (min-width: $xl){
            top: 330px;
          }
        }
      }
      &.three {
        background: url('../../static/images/third_hero_mobile.jpg') no-repeat;
        background-size: cover;
        @media all and (min-width: $md){
          background: url('../../static/images/third_hero.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $lg){
          background: url('../../static/images/third_hero@1x.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $xl){
          background: url('../../static/images/third_hero@2x.jpg') no-repeat;
          background-size: contain;
        }
        .parallax-wrapper {
          // top: 1350px;
          top: 100px;
          position: relative;
          @media all and (min-width: $md){
            top: 150px;
          }
          @media all and (min-width: $lg){
            top: 250px;
          }
          @media all and (min-width: $xl){
            top: 320px;
          }
          span, h2 {
            text-align: left;
            display: block;
          }
        }
      }
      &.four {
        background: url('../../static/images/fourth_hero_mobile.jpg') no-repeat;
        background-size: cover;
        @media all and (min-width: $md){
          background: url('../../static/images/fourth_hero.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $lg){
          background: url('../../static/images/fourth_hero@1x.jpg') no-repeat;
          background-size: contain;
        }
        @media all and (min-width: $xl){
          background: url('../../static/images/fourth_hero@2x.jpg') no-repeat;
          background-size: contain;
        }
        .parallax-wrapper {
          // top: 1750px;
          top: 145px;
          position: relative;
          @media all and (min-width: $md){
            top: 250px;
          }
          @media all and (min-width: $lg){
            top: 350px;
          }
          @media all and (min-width: $xl){
            top: 500px;
          }
        }
      }
    }
    .photo-grid > div {
      display: inline-block;
    }
    .section-statistics {
      padding: 0;
      text-align: center;
      background: transparent;
      transform: skew(0deg,5deg);
      -ms-transform: skew(0deg,2.5deg);
      -ms-transform: skew(0deg,0deg);
      -webkit-transform: skew(0deg,2.5deg);
      &:last-child {
        padding-bottom: 0;
      }
      .statistics-bg {
        background: $white;
        height: 100px;
        width: 100%;
        &.upper {
          margin-top: -30px;
        }
        &.lower {
          margin-bottom: -30px;
          box-shadow: 0 -5px 0 rgba(0,0,0,0.5);
        }
        @media all and (min-width: $md){
          height: 120px;
          &.lower {
            height: 150px;
          }
        }
      }
      .statistics-wrapper {
        transform: skew(0deg,-2.5deg);
        -ms-transform: skew(0deg,-2.5deg);
        -ms-transform: skew(0deg,0deg);
        -webkit-transform: skew(0deg,-2.5deg);
        padding: 100px 0;
        position: relative;
        @media all and (min-width: $md){
          padding: 100px 0;
          display: inherit;
          height: 500px;
          .parallax-wrapper {
            display: inherit;
          }
        }
        @media all and (min-width: $lg){
          @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            display: block;
          }
        }
        .parallax-wrapper {
          position: relative;
          -webkit-transform-origin: 0 0;
          -ms-transform-origin: 0 0;
          transform-origin: 0 0;
        }
        .col-md-4 {
          color: $white;
          font-weight: bold;
          font-size: 16px;
          text-transform: uppercase;
          transform: skew(0deg,-2.5deg);
          -ms-transform: skew(0deg,-2.5deg);
          -ms-transform: skew(0deg,0deg);
          -webkit-transform: skew(0deg,0deg);
          padding: 10px 0;
          @media all and (min-width: $md){
            font-size: 20px;
          }
          @media all and (min-width: $lg){
            font-size: 22px;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
               /* IE10+ specific styles go here */
               height: auto;
               min-height: 300px;
               display: inline-block;
               float: left;
            }
          }
          .stats-border-wrapper {
            padding: 10px 0 0;
            margin: 0 20%;
            border-top: 5px solid $white;
            @media all and (min-width: $md){
              margin: 0 10%;
            }
            @media all and (min-width: $lg){
              padding: 40px 0 0;
              @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                margin: 0 20%;
              }
            }
            &:before {
              content: "";
              border-top: 5px solid $orange;
              display: block;
              position: relative;
              top: -12px;
              left: 5px;
              @media all and (min-width: $lg){
                top: -42px;
              }
            }
            .numbers {
              font-size: 35px;
              line-height: 42px;
              @media all and (min-width: $md){
                font-size: 40px;
                line-height: 55px;
              }
              @media all and (min-width: $lg){
                font-size: 60px;
                line-height: 75px;
              }
            }
          }
        }
      }
    }
    .section-quote {
      color: $white;
      &.section-transparent .transparent-wrapper {
        padding: 90px 5%;
      }
      .quote-wrapper {
        padding: 40px 34px;
        position: relative;
        text-align: center;
        @media all and (min-width: $lg){
          // padding: 30px 50px;
          padding: 15px 30px;
          padding-left: 0;
          text-align: left;
        }
        .quote-svg {
          background: url('../assets/quote.svg') no-repeat;
          background-size: 33px;
          position: absolute;
          top: 15px;
          left: 15px;
          width: 33px;
          height: 33px;
          @media all and (min-width: $lg){
            top: -10px;
            left: -33px;
          }
        }
        .quote {
          font-weight: bold;
          font-size: 24px;
          line-height: 34px;
          span {
            font-weight: normal;
            font-size: 22px;
            font-weight: bold;
          }
          @media all and (min-width: $md){
            font-size: 31px;
            line-height: 40px;
          }
        }
      }
    }
    .section-transparent {
      background: transparent;
      transform: skew(0deg,5deg);
      -ms-transform: skew(0deg,2.5deg);
      -ms-transform: skew(0deg,0deg);
      -webkit-transform: skew(0deg,2.5deg);
      padding: 0;
      color: $white;
      &:before {
        content: "";
        background: $white;
        height: 120px;
        width: 100%;
        margin-top: -30px;
      }
      &:after {
        content: "";
        background: $white;
        height: 120px;
        width: 100%;
        margin-bottom: -30px;
        box-shadow: 0 -5px 0 rgba(0,0,0,0.5);
        @media all and (min-width: $md){
          height: 150px;
        }
      }
      &.top-only {
        padding-bottom: 200px;
        &:after {
          display: none;
        }
      }
      &.bottom-only {
        &:before {
          display: none;
        }
      }
      .transparent-wrapper {
        transform: skew(0deg, -2.5deg);
        -ms-transform: skew(0deg, -2.5deg);
        -ms-transform: skew(0deg, 0deg);
        -webkit-transform: skew(0deg, -2.5deg);
        padding: 0 5%;
        display: inherit;
        flex-wrap: wrap;
        width: 100%;
      }
      div[class^="col-"] {
        transform: skew(0deg,-2.5deg);
        -ms-transform: skew(0deg,-2.5deg);
        -ms-transform: skew(0deg,0deg);
        -webkit-transform: skew(0deg,0deg);
      }

    }
    .section-body {
      text-align: left;
    }
    &#intro .section-statistics .parallax-wrapper {
      top: 50px;
      @media all and (min-width: $md){
        top: 100px;
        @media not all and (min-resolution:.001dpcm) { @supports (-webkit-appearance:none) and (stroke-color:transparent) {
            top: 0;
          }
        }
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          top: 0;
        }
      }
    }
    &#intro {
      .row.section-statistics .statistics-bg.lower {
        box-shadow: 0 -5px 0 #141B4D;
      }
    }
    &#first .section-statistics .parallax-wrapper {
      top: 450px;
      @media all and (min-width: $md){
        top: 500px;
      }
      @media not all and (min-resolution:.001dpcm) { @supports (-webkit-appearance:none) and (stroke-color:transparent) {
          top: 0;
        }
      }
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        top: 0;
      }
    }
    &#first {
      .row.section-transparent:after {
        box-shadow: 0 -5px 0 #29C1A7;
      }
      .row.section-statistics .statistics-bg.lower {
        box-shadow: 0 -5px 0 #29C1A7;
      }
    }
    &#second .section-statistics .parallax-wrapper {
      top: 640px;
      @media all and (min-width: $md){
        top: 640px;
        @media not all and (min-resolution:.001dpcm) { @supports (-webkit-appearance:none) and (stroke-color:transparent) {
            top: 0;
          }
        }
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          top: 0;
        }
      }
    }
    &#second {
      .row.section-transparent:after {
        box-shadow: 0 -5px 0 #CC9400;
      }
      .row.section-statistics .statistics-bg.lower {
        box-shadow: 0 -5px 0 #CC9400;
      }
    }
    &#second .section-statistics .statistics-wrapper .col-md-4 .stats-border-wrapper:before {
      // box-shadow: 0 -5px 0 #CC9400;
      border-top: 5px solid #1e22aa;
    }
    &#third {
      .row.section-transparent:after {
        box-shadow: 0 -5px 0 #BA3E2C;
      }
      .row.section-statistics .statistics-bg.lower {
        box-shadow: 0 -5px 0 #BA3E2C;
      }
    }
    &#fourth {
      .row.section-transparent:after {
        box-shadow: 0 -5px 0 #0B0F2C;
      }
      .row.section-statistics .statistics-bg.lower {
        box-shadow: 0 -5px 0 #0B0F2C;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Body.vue